import React, { useEffect } from 'react'
import _ from 'lodash'
import './style.scss'

// --------------------------------------------------------------------------------------------
//  Responsive Table Component
//
//  Based on: https://techblog.livingsocial.com/blog/2015/04/06/responsive-tables-in-pure-css/
// --------------------------------------------------------------------------------------------

var cols = {
  payment: 'Payment',
  date: 'Processing Date',
  amount: 'Amount',
  payee: 'Payee',
}

var rows = [
  {
    payment: 'Payment #1',
    date: 'March 20, 1989',
    amount: '$29.99',
    payee: 'John Smith',
  },
  {
    payment: 'Payment #2',
    date: 'March 22, 1989',
    amount: '$40.00',
    payee: 'Brandon Drew',
  },
  {
    payment: 'Payment #3',
    date: 'April 2, 1989',
    amount: '$9.50',
    payee: 'Jackie Chan',
  },
]

const TableResponsiveOK = (props) => {
  const _head = () => {
    var columns = _.map(props.columns, function(colName) {
      return <th>{colName}</th>
    })
    return <tr>{columns}</tr>
  }

  const _rows = () => {
    return _.map(props.rows, function(row) {
      var values = _.map(props.columns, function(colName, colKey) {
        return <td data-label={colName}>{row[colKey]}</td>
      })
      return <tr>{values}</tr>
    })
  }

  useEffect(() => {
    console.log(_rows())
  }, [])

  return (
    <React.Fragment>
      <table className="responsive-table">
        <thead>{_head()}</thead>
        <tbody>{_rows()}</tbody>
      </table>
    </React.Fragment>
  )
}

export default TableResponsiveOK
